import { BehaviorSubject } from 'rxjs';
import { Dispatch, SetStateAction } from 'react';
import systemGroups from './GroupService';
import { GroupUnion } from '../models/GroupUnion';
import { GetSystemResponse, UnitDefinition } from '../models/Api';

const initialState: GroupUnion[] = [] as GroupUnion[];

const state$ = new BehaviorSubject<GroupUnion[]>(initialState);

const setState = (data: GroupUnion[]) => {
  return state$.next([...data]);
};

const GroupStateService = {
  fetchGroups: async (system: GetSystemResponse | undefined, unitDefinitions: UnitDefinition[]) => {
    const groups = systemGroups(system as GetSystemResponse, unitDefinitions);
    setState(groups);
  },

  getState: (setGroups: Dispatch<SetStateAction<GroupUnion[]>>) => {
    return state$.asObservable().subscribe((next) => setGroups(next));
  },

  getCurrentState: () => {
    return state$.value;
  },
};

export default GroupStateService;
